import { useStore } from '@nanostores/react';
import { memo, useCallback } from 'react';
import { AssistantActionButton, AssistantActionButtons } from '~/components/chat/AssistantActionButtons';
import { chatStore } from '~/lib/stores/chat';
import { userStore } from '~/lib/stores/user';
import { workbenchStore } from '~/lib/stores/workbench';
import type { ChatMessage } from '~/types/chat';

export const AssistantMessageButtons = memo(({ message }: { message: ChatMessage }) => {
  const user = useStore(userStore.user);
  const isStreaming = useStore(workbenchStore.isStreaming);

  const reportIssue = useCallback(() => {
    chatStore.isDiscordModalOpen.set(true);
  }, []);

  const showDebugInfo = useCallback(() => {
    chatStore.isDebugInfoModalOpen.set(message);
  }, []);

  return (
    <AssistantActionButtons>
      <AssistantActionButton disabled={isStreaming} onClick={reportIssue}>
        <div className="i-ph:warning text-lg" />
        Report issue
      </AssistantActionButton>

      {user?.featureFlags?.debugger && (
        <AssistantActionButton onClick={showDebugInfo}>
          <div className="i-ph:bug text-lg" />
          Show debug info
        </AssistantActionButton>
      )}
    </AssistantActionButtons>
  );
});
